<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/components/views/agro_exporter/quality_control/container/export_quality_inspect_info.yml"
  lang="yaml"
></i18n>
<template>
  <div class="my-8" v-if="quality_inspect">
    <div class="panel">
      <div class="panel-header columns-2">
        <h3 class="panel-header-title">{{ $t("labels.title") }}</h3>
      </div>

      <div class="panel-body" v-show="open">
        <div class="divide-y divide-slate-200">
          <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-2">
            <div class="sm:col-span-1">
              <dt class="label-data">
                {{ $t("model.quality_inspect.week") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.week }}
              </dd>
            </div>

            <div class="sm:col-span-1">
              <dt class="label-data">
                {{ $t("model.quality_inspect.registered_at") }}
              </dt>
              <dd class="content-data">
                {{ dateFormatterDayMonthName(quality_inspect.registered_at) }}
              </dd>
            </div>
            <div class="sm:col-span-1">
              <dt class="label-data">
                {{ $t("model.quality_inspect.inspect_code") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.inspect_code }}
              </dd>
            </div>
            <div class="sm:col-span-1" v-if="producerOrOrganizationLabel(quality_inspect.exported_batch)">
              <dt class="label-data">
                {{ $t("model.quality_inspect.provider") }}
              </dt>
              <dd class="content-data">
                {{
                  producerOrOrganizationLabel(quality_inspect.exported_batch)
                }}
              </dd>
            </div>
            <div
              class="sm:col-span-1"
              v-if="quality_inspect?.quality_template?.use_samplings"
            >
              <dt class="label-data">
                {{ $t("model.quality_inspect.samplings") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.samplings }}
              </dd>
            </div>
            <div class="sm:col-span-1">
              <dt class="label-data">
                {{ $t("model.quality_inspect.quality_accepted_percent") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.quality_accepted_percent }}%
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.quality_inspect.observations") }}
              </dt>
              <dd class="content-data">
                {{ quality_inspect.observations }}
              </dd>
            </div>
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <div class="panel-footer-actions">
          <destroy-button
            v-if="!proc_button_destroy"
            :disabled_button="false"
            @destroyEvent="destroyQualityInspect()"
            :label="$t('labels.destroy_button_label')"
            :title="$t('labels.destroy_button_title')"
            :message="$t('labels.destroy_button_message')"
            :label_confirm="$t('labels.destroy_button_label_confirm')"
          />
          <destroy-button-processing
            v-else
            :label="$t('labels.destroy_button_label')"
          />

          <span class="space-actions"></span>
          <edit-button
            @click.prevent="goToEditQualityInspect()"
            :label="$t('labels.edit_button')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerQualityRequester from "@/views/agro_exporter/requesters/quality_control/container/show_export_quality_inspect.js";

export default {
  name: "QualityInspectInfo",
  data: () => ({
    open: true,
    proc_button_destroy: false
  }),
  props: {
    quality_inspect: {
      type: Object,
      required: true,
    },
    exporter_process_quality_template_id: {
      required: true,
    },
    container_id: {
      required: true,
    },
  },
  methods: {
    producerOrOrganizationLabel(exported_batch) {
      if (!exported_batch) return;
      let label = "";
      if (exported_batch.producer) label += exported_batch.producer.name;
      if (exported_batch.organization) {
        if (label) label += ` (${exported_batch.organization.name})`;
        else label += exported_batch.organization.name;
      }
      return label;
    },
    goToEditQualityInspect: function () {
      this.$router.push({
        name: "ae_quality_control_container_edit_inspection_path",
        params: {
          container_id: this.container_id,
          quality_inspect_id: this.quality_inspect.id,
          quality_template_id: this.quality_inspect.quality_template_id,
        },
      });
    },
    goToListQualityInspects: function () {
      this.$router.push({
        name: "ae_quality_control_container_list_quality_inspects_path",
        params: {
          container_id: this.container_id,
          exporter_process_quality_template_id:
            this.exporter_process_quality_template_id,
        },
      });
    },
    destroyQualityInspect: async function () {
      this.proc_button_destroy = true;
      try {
        let response =
          await ContainerQualityRequester.destroyExportQualityInspect(
            this.quality_inspect.id
          );
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToListQualityInspects();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
      this.proc_button_destroy = false;
    },
  },
};
</script>
